import React from 'react';

function ScrollDownSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="24"
      fill="none"
      viewBox="0 0 16 24"
    >
      <path
        fill="#fff"
        d="M7.776 23.955a.598.598 0 00.446 0c.03-.012.054-.034.082-.05.033-.02.069-.034.099-.061l6.6-6a.6.6 0 00-.808-.888L8.6 22.043V.6a.6.6 0 10-1.2 0v21.443l-5.596-5.088a.6.6 0 00-.808.889l6.6 6c.03.027.066.04.099.06.028.017.051.039.082.051z"
      ></path>
    </svg>
  );
}

export default ScrollDownSvg;
